import React, { useState, useEffect } from 'react';
import { Clock, Calendar } from 'lucide-react';

const LiveClock = () => {
  const [time, setTime] = useState(new Date());
  const [showDate, setShowDate] = useState(false);

  useEffect(() => {
    // Update time every second
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    // Switch between time and date every 7 seconds
    const switcher = setInterval(() => {
      setShowDate(prev => !prev);
    }, 7000);

    // Cleanup on unmount
    return () => {
      clearInterval(timer);
      clearInterval(switcher);
    };
  }, []);

  // Format time to HH:MM:SS using user's timezone
  const formatTime = (date) => {
    return new Intl.DateTimeFormat('tr-TR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }).format(date);
  };

  // Format date to "2025.11.25" format
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${year}.${month}.${day}`;
  };

  return (
    <div className="flex items-center space-x-1.5 sm:space-x-2 px-2 sm:px-3 py-1.5 sm:py-2 min-w-[110px] sm:min-w-[150px] justify-center">
      {showDate ? (
        <>
          <Calendar className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#8B7355] flex-shrink-0" />
          <span className="text-xs sm:text-sm font-medium text-[#8B7355] whitespace-nowrap">
            {formatDate(time)}
          </span>
        </>
      ) : (
        <>
          <Clock className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#8B7355] flex-shrink-0" />
          <span className="font-mono text-xs sm:text-sm font-medium text-[#8B7355] tracking-wider">
            {formatTime(time)}
          </span>
        </>
      )}
    </div>
  );
};

export default LiveClock;
